import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { SingleSizeIllustrationExtTick } from '@xing-com/illustrations';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  space3XL,
  spaceXXL,
  spaceL,
  xdlColorTextSecondary,
  spaceXL,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  padding-bottom: ${spaceL};
`;

export const Title = styled(Headline).attrs({ size: 'xxlarge' })`
  margin-top: ${space3XL};
  margin-bottom: 0;

  &:focus {
    outline: none;
  }
`;

export const StepList = styled.ul`
  list-style: none;
  padding: 0;
  margin: ${spaceL} 0;
`;

export const StepItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${spaceXXL} 0;
  gap: ${spaceL};
`;

export const StepTick = styled(SingleSizeIllustrationExtTick).attrs({
  width: 24,
  height: 24,
})`
  flex-shrink: 0;
`;

export const StepTitle = styled(Headline).attrs({
  noMargin: true,
  size: 'large',
})`
  display: flex;
  align-items: center;
  gap: ${spaceL};
  color: ${xdlColorTextSecondary};
`;

export const LegalInfoWrapper = styled.div`
  margin: ${spaceXXL} 0 ${space3XL};
`;

export const CTAButton = styled(Button).attrs({
  variant: 'primary',
})`
  width: 100%;
  margin-top: auto;

  @media ${mediaConfined} {
    margin-top: 0;
  }
`;

export const CTAWrapper = styled.div`
  @media ${mediaConfined} {
    padding: 0 ${spaceXL};
  }
`;
